module.exports = __webpack_public_path__ + "70f916453b2069e94821c0701abd7187.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/pumpkin.png
// module id = 2424
// module chunks = 0